import { SupplierStatus } from '@/types/suppliers/SupplierStatus';
import { useTranslation } from '@/i18n';

const SupplierStatusCell = ({ status }: { status: SupplierStatus }) => {
  const { t } = useTranslation();
  const colorMap = {
    [SupplierStatus.PUBLISHED]:
      'border-success-200 bg-success-50 text-success-700',
    [SupplierStatus.DRAFT]: 'border-warning-200 bg-warning-50 text-warning-700',
  };
  return (
    <span
      className={`px-2 py-0.5 border rounded-lg text-sm font-medium ${colorMap[status]}`}
    >
      {status === SupplierStatus.PUBLISHED
        ? t('common.status.published')
        : t('common.status.draft')}
    </span>
  );
};

export default SupplierStatusCell;
